import ColetaAmiga from "./ColetaAmiga";
import Investimentos from "./Investimentos";
import WebAntigo from "./WebAntigo";

const Projects = [ 
  ColetaAmiga,
  Investimentos,
  WebAntigo
];

export default Projects;